import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { ApiToken, ApiTokenUser } from '../interfaces'
import type { ApiTokensStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

const getMeta = (state: ApiTokensStore): Meta | null => state.tokensPaginatedData?.meta || null
const getTokens = (state: ApiTokensStore): ApiToken[] => state.tokensPaginatedData?.tokens || []
const getUsers = (state: ApiTokensStore): ApiTokenUser[] => state.tokensPaginatedData?.users || []

export const getters = {
  isLoading: (state: ApiTokensStore): ApiTokensStore['loading'] => state.loading,
  getFilterUserId: (state: ApiTokensStore): ApiTokensStore['filterUserId'] => state.filterUserId,
  getFilterSearch: (state: ApiTokensStore): ApiTokensStore['filterSearch'] => state.filterSearch,
  getTokens: (state: ApiTokensStore): ApiToken[] => getTokens(state),
  hasTokens: (state: ApiTokensStore): boolean => isFullArray(getTokens(state)),
  getUsers: (state: ApiTokensStore): ApiTokenUser[] => getUsers(state),
  getUserOptions: (state: ApiTokensStore): AppSelectOption<number>[] =>
    getUsers(state).map(user => ({ value: user.id, text: user.name })),
  getMeta: (state: ApiTokensStore): Meta | null => getMeta(state),
  getCurrentPage: (state: ApiTokensStore): number => getMeta(state)?.current_page || 1,
  getLastPage: (state: ApiTokensStore): number => getMeta(state)?.last_page || 1,
  getPerPage: (state: ApiTokensStore): number => getMeta(state)?.per_page || 25,
  isModalEdit: (state: ApiTokensStore): boolean => state.tokenToEdit !== null,
  isModalDelete: (state: ApiTokensStore): boolean => state.tokenToDelete !== null,
}
